export default [
    {
        path: '/home',
        name: 'home',
        component: () => import('@/pages/home/IndexPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/rewards',
        name: 'rewards',
        component: () => import('@/pages/rewards/RewardsIndexPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/motorcycles',
        name: 'motorcycles',
        component: () => import('@/pages/motorcycles/MotorcyclesIndexPage.vue'), //TODO: update actual component
        meta: { requiresAuth: true },
    },
    {
        path: '/chat',
        name: 'chat',
        component: () => import('@/pages/chats/ChatIndexPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/chat/inquiry',
        name: 'chat-inquiry',
        component: () => import('@/pages/chats/ChatViewPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/chat/history',
        name: 'chat-history',
        component: () => import('@/pages/chats/ChatHistoryPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/transactions',
        name: 'transactions',
        component: () => import('@/pages/home/transactions/TransactionsIndexPage.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/home/transactions/:transaction/view',
        name: 'transactions-view',
        component: () => import('@/pages/home/transactions/TransactionsViewPage.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/home/transactions/payment-breakdown/:applicationHashId',
        name: 'payment-breakdown',
        component: () => import('@/pages/home/transactions/PaymentBreakdownPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/loans',
        name: 'loans',
        component: () => import('@/pages/home/loans/LoansIndexPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/loans/application',
        name: 'loans-application',
        component: () => import('@/pages/home/loans/LoansApplicationPage.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/home/loans/application/success',
        name: 'loans-application-success',
        component: () => import('@/pages/home/loans/LoansApplicationSuccessPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/loans/pay',
        name: 'loans-pay',
        component: () => import('@/pages/home/loans/LoanPaymentPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/loans/pay/success',
        name: 'loans-pay-success',
        component: () => import('@/pages/home/loans/LoanPaymentSuccessPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/loans/:hashId',
        name: 'loans-detail',
        component: () => import('@/pages/home/loans/LoanApplicationDetailPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/refer-and-earn',
        name: 'refer-and-earn',
        component: () => import('@/pages/home/refer-and-earn/ReferEarnIndexPage.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/home/refer-and-earn/tiers',
        name: 'refer-and-earn-tiers',
        component: () => import('@/pages/home/refer-and-earn/ReferEarnTiersPage.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/home/calculator',
        name: 'calculator',
        component: () => import('@/pages/home/calculator/CalculatorIndexPage.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/rewards/success',
        name: 'rewards-success',
        component: () => import('@/pages/rewards/RewardsSuccessPage.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/rewards/available-rewards',
        name: 'rewards-available',
        component: () => import('@/pages/rewards/available-rewards/RewardsIndexPage.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/motorcycles/:id',
        name: 'motorcycles-view',
        component: () => import('@/pages/motorcycles/MotorcyclesViewPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/motorcycles/:id/purchase',
        name: 'motorcycles-purchase',
        component: () => import('@/pages/motorcycles/MotorcyclesPurchasePage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/motorcycles/:id/purchase/success',
        name: 'motorcycles-purchase-success',
        component: () => import('@/pages/motorcycles/MotorcyclesPurchaseSuccess.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/motorcycles/my-motorcycles',
        name: 'motorcycles-my-motorcycles',
        component: () => import('@/pages/motorcycles/MyMotorcyclesIndexPage.vue'),
        meta: { requiresAuth: true }, // false for now
    },
    {
        path: '/home/profile',
        name: 'profile',
        component: () => import('@/pages/home/profile/ProfileIndexPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/profile/edit',
        name: 'profile-edit',
        component: () => import('@/pages/home/profile/ProfileEditPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/profile/password-update',
        name: 'profile-password-update',
        component: () => import('@/pages/home/profile/ProfilePasswordUpdatePage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/promos',
        name: 'promos-advisories',
        component: () => import('@/pages/promos-advisories/PromosIndexPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/promos/promos/:id',
        name: 'promos-view',
        component: () => import('@/pages/promos-advisories/PromosViewPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/promos/advisories/:id',
        name: 'advisories-view',
        component: () => import('@/pages/promos-advisories/AdvisoriesViewPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/branch-locator',
        name: 'branch-locator',
        component: () => import('@/pages/home/branch-locator/BranchLocatorPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/home/link-card',
        name: 'link-card',
        component: () => import('@/pages/home/link-card/LinkCardPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: () => import('@/pages/notifications/NotificationIndexPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/notifications/type/:type',
        name: 'notification-type',
        component: () => import('@/pages/notifications/NotificationSlugPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/notifications/slug/:slug',
        name: 'notification-slug',
        component: () => import('@/pages/notifications/NotificationSlugPage.vue'),
        meta: { requiresAuth: true },
    },
];
